<template>
<div class="calculation_area my-2 px-2 pb-2 ">	


<!--controls-->


<Menubar :model="menuitems">

</Menubar>




<!--controls-->

<CalculationStage :nodes="$store.state.calculations.nodes" :connections="$store.state.calculations.connections"></CalculationStage>

<CalculationSidebar></CalculationSidebar>

</div>
</template>

<script>
import CalculationStage from "./CalculationStage"
import CalculationSidebar from "./CalculationSidebar"
 
export default {

  name: 'QuestionlistCalculationRoot',
  props:["questionlists","nodesdata","questionlistoptions","inputfieldclasses"],
  components:{CalculationStage,CalculationSidebar},
  data () {
    return {
    	menuitems:[
	    	//sources
	    	{    		
	    		label:"Kaynaklar",
	    		key:"sources",
	    		icon:'pi pi-fw pi-sitemap',
	    		items:[
		    		{
		    			label:"Tedarikçiler",
		    			type:"suppliers",
		    			key:"sources",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
    			]
    		},
	    	//sources
	    	//conditions
	    	{    		
	    		label:"Filtre",
	    		key:"conditions",
	    		icon:'pi pi-fw pi-sliders-h',
	    		items:[
		    		{
		    			label:"Özel Nitelik",
		    			type:"customattribute",
		    			key:"conditions",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Proje",
		    			type:"project",
		    			key:"conditions",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Aşama",
		    			type:"flow",
		    			key:"conditions",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Dahil Olunan Projeler",
		    			type:"projects",
		    			key:"conditions",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Dahil Olunan Aşamalar",
		    			type:"flows",
		    			key:"conditions",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Dahil Edilmeyecek Firmalar",
		    			type:"exempt_suppliers",
		    			key:"conditions",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		/*
		    		{
		    			label:"Çıktı Verisi",
		    			type:"output",
		    			key:"conditions",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},*/
    			]
	    	},
	    	//conditions
	    	//datalayer
	    	/*
	    	{    		
	    		label:"Veri",
	    		key:"datalayer",
	    		icon:'pi pi-fw pi-file-o',
	    		items:[
	    			{
		    			label:"Birleştir",
		    			type:"merge",
		    			key:"datalayer",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Farkları Çıkar",
		    			type:"differenciate",
		    			key:"datalayer",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
	    		]
	    	},*/
	    	//datalayer
	    	//calculations
	    	{    		
	    		label:"Hesaplamalar",
	    		key:"calculations",
	    		icon:'pi pi-fw pi-pencil',
	    		items:[
		    		{
		    			label:"Toplama",
		    			type:"addition",
		    			key:"calculations",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Çıkarma",
		    			type:"subtraction",
		    			key:"calculations",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Çarpma",
		    			type:"multiplication",
		    			key:"calculations",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Bölme",
		    			type:"division",
		    			key:"calculations",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
    			]
	    	},
	    	//calculations  
	    	//logicals
	    	{    		
	    		label:"Mantıksal Operatörler",
	    		key:"logicals",
	    		icon:'pi pi-fw pi-sort-alt',
	    		items:[
		    		{
		    			label:"Koşullu Veri",
		    			type:"conditional_logic",
		    			key:"logicals",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Özel Nitelik Çevirici",
		    			type:"customattribute_morph",
		    			key:"logicals",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
    			]
    		},
	    	//logicals  	
	    	//outputs
	    	{    		
	    		label:"Görünüm",
	    		key:"outputs",
	    		icon:'pi pi-fw pi-table',
	    		items:[
		    		{
		    			label:"Liste",
		    			type:"list",
		    			key:"outputs",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Grup",
		    			type:"group",
		    			key:"outputs",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
		    		{
		    			label:"Grafik Çizelge",
		    			type:"chart",
		    			key:"outputs",
			    		command: (event) => {
			    			this.addNode(event.item.type,event.item.key,event.item.label)
			    		},
		    		},
    			]
	    	},
	    	//outputs
    	],
    	nodes:[],
    	connections:[],
    	node:{
			id:null,
			title:null,
			offsetX:10,
			offsetY:10,
			type:null,
			key:null,
			outputs:[],
			data:null,
			inputs:[]
		},
		connection:{
			id:null,
			x1:null,
			y1:null,
			x2:null,
			y2:null,
			from:null,
			to:null,
			drawing:true,
		},
		operators:[
		{name:"Toplama",code:"addition"},
		{name:"Çıkarma",code:"subtraction"},
		{name:"Çarpma",code:"multiplication"},
		{name:"Bölme",code:"division"},
		{name:"Koşul",code:"condition"},
		{name:"Eşittir",code:"equation"},
		],
		container:null,
		currentX:0,
    	currentY:0,
    	initialX:0,
    	initialY:0,
    	xOffset:0,
    	yOffset:0,
    	drag_active:false,
    	draw_active:false,
    	dragged_element:null,
    	adding_item:false,
    	adding_variable:false,
    	adding_operator:false,
		selectedquestionlistoption:null,
		selectedinputfieldclass:null,
		selectedcolumn:null,
		selectedoperator:null,
        inputfields:[],
        columns:[],
        loading_inputfields:false,
        loading_columns:true,
    }
  },
  computed:{
  	nodemoved()
  	{
  		return this.$store.state.calculations.nodedragging
  	},
  	connectioncreated()
  	{
  		return this.$store.state.calculations.connectioncreated
  	},
  },
  watch:{
  	nodesdata(newval)
  	{
  		
  		let nodesdata = JSON.parse(this.nodesdata)
  		
  		this.$store.dispatch('calculations/setNodes',nodesdata.nodes)
  		this.$store.dispatch('calculations/setConnections',nodesdata.connections)
  	},
  	nodemoved(newval)
  	{  		
  		if(!newval)
  		{

  		}
  	},
  	connectioncreated(newval)
  	{  		

  		if(newval)
  		{
  			

  			
  		}
  	}
  },
  mounted()
  {
  	this.$store.state.calculations.stagezoom = 1
  	this.$store.dispatch('calculations/setNodes',[])
  	this.$store.dispatch('calculations/setConnections',[])
  	this.$store.dispatch('calculations/setSelectedConnection',null)
  	this.container = document.querySelector("#calculation_stage");

  	this.container.addEventListener("touchstart", this.dragStart, false);
    this.container.addEventListener("touchend", this.dragEnd, false);
    this.container.addEventListener("touchmove", this.drag, false);
    this.container.addEventListener("mouseover", this.pointerenter, false);

    
  	this.container.addEventListener("mousedown", this.dragStart, false);
    this.container.addEventListener("mouseup", this.dragEnd, false);
    this.container.addEventListener("mousemove", this.drag, false);
    this.container.addEventListener("mouseover", this.overNotch, false);
    this.container.addEventListener("wheel", this.zoomStage, false);
    
	if(this.nodesdata)
  	{
  		
  		let nodesdata = JSON.parse(this.nodesdata)
  		
  		this.$store.dispatch('calculations/setNodes',nodesdata.nodes)
  		this.$store.dispatch('calculations/setConnections',nodesdata.connections)
  	}

  	

  },
  methods:{
  	addNode(type,key,label)
  	{
  		
  		let supplier_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.type ==type})
  		/*
  		if(supplier_ind!==-1)
  		{
  			this.showMessage("error","Bir rapora sadece tek tedarikçi modülü eklenebilir","")
  			return false
  		}*/

  		if(key=="outputs")
  		{
  			let output_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.type =="list" || item.type =="chart"})
	  		if(output_ind!==-1)
	  		{
	  			this.showMessage("error","Bir rapora sadece tek görünüm modülü eklenebilir","")
	  			return false
	  		}
  		}

  		if(key=="sources")
  		{
  			let output_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.key =="sources"})
	  		if(output_ind!==-1)
	  		{
	  			this.showMessage("error","Bir rapora sadece tek tedarikçi modülü eklenebilir","")
	  			return false
	  		}
  		}
  		
  				
    	


    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = label
  		node.type=type
  		node.key=key

  		if(type=="suppliers")
  		{
  			node.data = {
  				outputs:[]
  			}
  		}
  		if(type=="project")
  		{
  			node.data = {
  				selected_project_id:null,
  				period_id:null,
  				selected_value:"included",
  				selected_operator:null,
  				selected_statuses:[],
  			}
  		}
  		if(type=="projects")
  		{
  			node.data = {
  				selected_project_id:null,
  				period_id:null,
  				selected_projects:[],
  			}
  		}
  		if(type=="flow")
  		{
  			node.data = {
  				selected_flow_id:null,
  				period_id:null,
  				selected_value:"included",
  				selected_operator:null,
  				selected_statuses:[],
  			}
  		}
  		if(type=="flows")
  		{
  			node.data = {
  				selected_flow_id:[],
  				period_id:null,
  				selected_flows:[],
  			}
  		}
  		if(type=="exempt_suppliers")
  		{
  			node.data = {
  				selected_suppliers:[],
  			}
  		}
  		if(key=="outputs")
  		{
  			node.data = {
  				outputs:[]
  			}
  		}

  		if(type=="customattribute")
  		{
  			node.data = {
  				selected_custom_attribute_id:null,
  				selected_value:null,
  				selected_operator:null,
  			}
  		}
  		if(key=="calculations")
  		{
  			node.data = {
  				output:{
  					inputs:[],
  					fraction:2,
  					name:null,
  				}
  			}
  		}
  		if(type=="conditional_logic")
  		{
  			node.data = {
  				logic_bundles:[],
  				name:null,
  			}
  		}

  		

  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)
      this.$store.dispatch('calculations/setSelectedNode',node)
      
      this.$store.dispatch('calculations/setSidebar',true)
      
       



  	},
  	dragStart(e)
  	{
  		//node drag start
  		//console.log(this.$store.state.calculations.nodes)
  		//console.log(this.$store.state.calculations.connections)
  		
  		if(e.target.classList.contains("calculation_connection") || e.target.classList.contains("calculation_stage"))
  		{
  			
  		}

  		let zoom = this.$store.state.calculations.stagezoom
  		if(e.target.classList.contains("calculation_node_header_text"))
  		{
  			let target_id = e.target.id.replace("handle","node")
  			let node_id = e.target.id.replace("handle","")
  			
        	let selected_node_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == node_id})
        	this.$store.dispatch('calculations/setSelectedNode',this.$store.state.calculations.nodes[selected_node_ind])
        	this.dragged_element = document.getElementById(target_id)  			
        	this.drag_active = true
        	
  		}
  		//right node drag start
  		if(e.target.classList.contains("calculation_node_right_notch"))
  		{
  			let from_id = e.target.id.replace("right_notch","")
  			let bounds = this.container.getBoundingClientRect();
      	let initialX = e.clientX - bounds.left
	     	let initialY = e.clientY - bounds.top
	     	let connection = this.sanitizeArray(this.connection)

	  		connection.id =  Math.floor(Date.now() / 10)
	  		connection.x1 = (initialX)/zoom;
    		connection.y1 = (initialY)/zoom;
    		connection.x2 = (initialX)/zoom;
    		connection.y2 = (initialY)/zoom;
    		connection.from = from_id

    		let connections = this.$store.state.calculations.connections
    		connections.push(connection)
    		this.$store.dispatch('calculations/setConnections',connections)
    		this.$store.dispatch('calculations/setSelectedConnection',connection)
    		let fromnode_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == from_id})
    		this.$store.dispatch('calculations/setFromNode',this.$store.state.calculations.nodes[fromnode_ind])
  			this.draw_active = true
  		}
  		//right node drag start



  	},
  	dragEnd(e)
  	{
        this.drag_active = false;
        if(this.draw_active)
        {
        	let selectedconnection = this.$store.state.calculations.selectedconnection
	        let connections = this.$store.state.calculations.connections
	        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
	        this.$store.dispatch('calculations/setConnections',connections)
        	this.draw_active = false;
        } 
  	},
  	drag(e)
  	{
  		let zoom = this.$store.state.calculations.stagezoom
  		if (this.drag_active) {
  			e.preventDefault();
  			let selectednode = this.$store.state.calculations.selectednode
  			let bounds = this.container.getBoundingClientRect();
  			selectednode.offsetX = (e.clientX - bounds.left - (90*zoom))/zoom
  			selectednode.offsetY = (e.clientY - bounds.top - (18*zoom))/zoom
  			let nodes = this.$store.state.calculations.nodes
  			let ind = nodes.findIndex((item)=>{return item.id ==selectednode.id})
  			nodes[ind] = selectednode
  			this.$store.dispatch('calculations/setNodes',nodes)

  			/*
  			this.currentX = e.clientX - this.initialX;
	        this.currentY = e.clientY - this.initialY;
	        this.xOffset = this.currentX;
	        this.yOffset = this.currentY;
	        */
	        //this.setTranslate(this.currentX, this.currentY, this.dragged_element);
	        this.updateConnectionNotches(selectednode.offsetX,selectednode.offsetY,selectednode.id);

  		}
  		if (this.draw_active) 
  		{
  			let bounds = this.container.getBoundingClientRect();
  			let currentX = e.clientX - bounds.left
        let currentY = e.clientY - bounds.top
        let active_connection = this.$store.state.calculations.selectedconnection
    		//console.log(active_connection)
    		active_connection.x2 = (currentX)/zoom;
    		active_connection.y2 = (currentY)/zoom;
    		let connections = this.$store.state.calculations.connections
    		let ind = connections.findIndex((item)=>{return  item.id == active_connection.id})
    		connections[ind] = active_connection
    		this.$store.dispatch('calculations/setConnections',connections)
    		let from_node = this.$store.state.calculations.nodes.find((item)=>{return item.id == active_connection.from})

    		this.updateConnectionNotches(from_node.offsetX,from_node.offsetY,from_node.id);

  		}

  	},
  	setTranslate(xPos, yPos, el) {
      el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
    },
    updateConnectionNotches(xPos,yPos,node_id)
    {
    	//let node = this.$store.state.calculations.nodes.find((item)=>{return item.id == node_id})
    	let from_connections = this.$store.state.calculations.connections.filter((item)=>{return item.from == node_id})
    	let to_connections = this.$store.state.calculations.connections.filter((item)=>{return item.to == node_id})
    	for(let con of from_connections)
    	{
    		con.x1 = xPos+193
    		con.y1 = yPos+18
    		con.drawing = false
    	}
    	for(let con of to_connections)
    	{
    		con.x2 = xPos -8
    		con.y2 = yPos +18
    		con.drawing = false
    	}
    },
    attachConnectionToNode(e,zoom,to_id,target_node)
    {
    	let element = document.getElementById(e.target.id)
			let selectedconnection = this.$store.state.calculations.selectedconnection
			let bounds = this.container.getBoundingClientRect();
			
			selectedconnection.x2 = (e.clientX - bounds.left +8)/zoom
			selectedconnection.y2 = (e.clientY - bounds.top +8)/zoom
			selectedconnection.to = to_id
			let connections = this.$store.state.calculations.connections
			let ind = connections.findIndex((item)=>{return item.id == selectedconnection.id})
			connections[ind] = selectedconnection
			this.$store.dispatch('calculations/setConnections',connections)
			let input_item = {connection_id:selectedconnection.id,type:"connection"}
			let the_ind = target_node.inputs.findIndex((item)=>{return item.connection_id == selectedconnection.id})
			if(the_ind==-1)
			{
				target_node.inputs.push(input_item)
			}
		
			let target_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == to_id})
			this.$store.state.calculations.nodes[target_ind] = target_node			
			let from_node_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == selectedconnection.from})
			this.draw_active = false;
			

			this.updateConnectionNotches(this.$store.state.calculations.nodes[target_ind].offsetX,this.$store.state.calculations.nodes[target_ind].offsetY,this.$store.state.calculations.nodes[target_ind].id);
    },


  	overNotch(e)
  	{
  		let zoom = this.$store.state.calculations.stagezoom
  		if(e.target.classList.contains("calculation_node_left_notch") && this.draw_active)
  		{
  			let to_id = e.target.id.replace("left_notch","")

  			let target_node = this.$store.state.calculations.nodes.find((item)=>{return item.id == to_id})
  			

  			//if condition type
  			/*
  			if(target_node.key=="conditions")
  			{
  				if(target_node.inputs.length>=1)
  				{
  					this.showMessage("error","Koşul modülüne en fazla bir değişken iliştirilebilir","")
  					let selectedconnection = this.$store.state.calculations.selectedconnection
		        let connections = this.$store.state.calculations.connections
		        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
		        this.$store.dispatch('calculations/setConnections',connections)
	        	this.draw_active = false;
	        	this.$store.state.calculations.fromnode = null
  					return  false
  				}
  				else
  				{
  					this.attachConnectionToNode(e,zoom,to_id,target_node)
  				}
  			}
  			//if condition type

  			else
  			{
  				this.attachConnectionToNode(e,zoom,to_id,target_node)
  			}


  			


  			if(target_node.type=="equation")
  			{
  				this.attachConnectionToNode(e,zoom,to_id,target_node)
  			*/
  			this.attachConnectionToNode(e,zoom,to_id,target_node)
  			

  			

  			
  		}
  		
  	},
  	zoomStage(e)
  	{
  		
  		e.preventDefault()
  		if(this.$store.state.calculations.stagezoom<1.5 && this.$store.state.calculations.stagezoom>0.5)
	  	{
	  		if(e.deltaY<0)
	  		{
	  			this.$store.state.calculations.stagezoom += 0.1
	  		}
	  		if(e.deltaY>0)
	  		{
	  			this.$store.state.calculations.stagezoom -= 0.1
	  		}
  		}
  		if(this.$store.state.calculations.stagezoom>1.5)
  		{
  			if(e.deltaY>0)
	  		{
	  			this.$store.state.calculations.stagezoom -= 0.1
	  		}
  		}

  		if(this.$store.state.calculations.stagezoom<0.5)
  		{
  			if(e.deltaY<0)
	  		{
	  			this.$store.state.calculations.stagezoom += 0.1
	  		}
  		}
  		

  	}
  }
}
</script>

<style lang="css" scoped>
</style>